import React, { useEffect, useState } from 'react';
import employeeQualificationService from '../../../services/EmployeeQualificationService';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import QualificationPendingItem from './QualificationPendingItem';

const QualificationPendingDialog = ({
  employeeId,
  qualificationName,
  setEmployeesQualifications,
  rows,
  changeDialogSizePExisting,
  setChangeDialogSizePExisting,
  changeDialogSizePUpdated,
  setChangeDialogSizePUpdated
}) => {
  const [qualificationRecord, setQualificationRecord] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchEmployeeUpdatedQualifications = async () => {
      try {
        setIsLoading(true);
        const employeeUpdatedQualifications = await employeeQualificationService.getEmployeeUpdatedQualification(
          employeeId,
          qualificationName
        );

        const qualificationRecord = employeeUpdatedQualifications?.data?.data;

        if (qualificationRecord.length) {
          setQualificationRecord(qualificationRecord);
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.message || 'Could not authenticate employee';
        toast.error(errorMessage);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEmployeeUpdatedQualifications();
  }, [employeeId, qualificationName]);

  return (
    <div>
      {isLoading ? (
        <div className="tw-flex tw-justify-center tw-py-8">
          <div className="tw-h-8 tw-w-8 tw-animate-spin tw-rounded-full tw-border-4 tw-border-blue-200 tw-border-t-blue-600" />
        </div>
      ) : qualificationRecord.length ? (
        qualificationRecord?.map((qualificationItem) => {
          return (
            <QualificationPendingItem
              qualificationItem={qualificationItem}
              key={qualificationItem[0]?.qualificationId || qualificationItem[1]?.qualificationId}
              setQualificationRecord={setQualificationRecord}
              employeeId={employeeId}
              setEmployeesQualifications={setEmployeesQualifications}
              rows={rows}
              qualificationName={qualificationName}
              changeDialogSizePExisting={changeDialogSizePExisting}
              setChangeDialogSizePExisting={setChangeDialogSizePExisting}
              changeDialogSizePUpdated={changeDialogSizePUpdated}
              setChangeDialogSizePUpdated={setChangeDialogSizePUpdated}
            />
          );
        })
      ) : null}
    </div>
  );
};

export default QualificationPendingDialog;

QualificationPendingDialog.propTypes = {
  employeeId: PropTypes.string,
  qualificationName: PropTypes.string,
  setEmployeesQualifications: PropTypes.func,
  rows: PropTypes.array,
  changeDialogSizePExisting: PropTypes.bool,
  setChangeDialogSizePExisting: PropTypes.func,
  changeDialogSizePUpdated: PropTypes.bool,
  setChangeDialogSizePUpdated: PropTypes.func
};
